import React from "react";

// Crisp inline SVG icons (stroke = currentColor) so the toolkit never depends on
// a specific material-icons font version. 24x24, 1.7 stroke, rounded.
const PATHS = {
  "find-email": (
    <>
      <rect x="3" y="5" width="18" height="14" rx="2.2" />
      <path d="m3.5 7.5 8.5 5.5 8.5-5.5" />
      <circle cx="18" cy="17.5" r="3.2" fill="var(--dt-card-bg, #fff)" />
      <path d="m20.4 19.9 1.6 1.6" />
    </>
  ),
  validate: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="m8.2 12.4 2.6 2.6 5-5.6" />
    </>
  ),
  "enrich-contacts": (
    <>
      <circle cx="10" cy="8" r="3.6" />
      <path d="M3.8 20c0-3.4 2.8-6 6.2-6 1.5 0 2.9.5 4 1.4" />
      <path d="M18 13.5v5M20.5 16h-5" />
    </>
  ),
  "enrich-accounts": (
    <>
      <path d="M4 21V5.5A1.5 1.5 0 0 1 5.5 4h7A1.5 1.5 0 0 1 14 5.5V21" />
      <path d="M14 10h4.5A1.5 1.5 0 0 1 20 11.5V21" />
      <path d="M7 8h4M7 12h4M7 16h4M17 14h0M17 17.5h0" />
      <path d="M2.5 21h19" />
    </>
  ),
  "data-magic": (
    <>
      <path d="m4 20 10-10" />
      <path d="m11.5 9.5 3 3" />
      <path d="M16 3v4M14 5h4" />
      <path d="M18.5 10.5v3M17 12h3" />
    </>
  )
};

const ToolIcon = ({ name, size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.7"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {PATHS[name] || null}
  </svg>
);

export default ToolIcon;
